import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight, Download, X } from "lucide-react";

export const Lightbox = ({ items, start = 0, onClose }) => {
  const [i, setI] = useState(start);
  const n = items.length;
  const go = (d) => setI((v) => (v + d + n) % n);
  useEffect(() => {
    window.__lenis?.stop();
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") setI((v) => (v + 1) % n);
      if (e.key === "ArrowLeft") setI((v) => (v - 1 + n) % n);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.__lenis?.start(); window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [onClose, n]);
  const it = items[i];
  const touchX = useRef(null);
  const onTouchEnd = (e) => {
    if (touchX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchX.current;
    touchX.current = null;
    if (dx < -50) go(1); else if (dx > 50) go(-1);
  };
  const navBtn = "absolute top-1/2 -translate-y-1/2 z-10 hidden sm:flex w-12 h-12 rounded-full border border-white/40 text-white items-center justify-center hover:bg-white hover:text-black transition-colors duration-300";
  return (
    <motion.div data-testid="lightbox" className="fixed inset-0 z-[80] bg-[#171411]/[0.98] flex flex-col"
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose}>
      <div className="flex items-center justify-between px-5 sm:px-10 py-5 text-white" onClick={(e) => e.stopPropagation()}>
        <span data-testid="lightbox-caption" className="text-[12px] uppercase tracking-[0.22em] text-[var(--gold-soft)]">{it.cap}</span>
        <div className="flex items-center gap-5">
          {it.download && (
            <a data-testid="lightbox-download-btn" href={it.src} download={`Mimi-Tao-${it.src.split("/").pop()}`}
              className="inline-flex items-center gap-2 rounded-full border border-white/40 px-4 py-2 text-[12px] uppercase tracking-[0.2em] text-white hover:bg-white hover:text-black transition-colors duration-300">
              <Download size={14} /> <span className="hidden sm:inline">Download</span>
            </a>
          )}
          <span data-testid="lightbox-counter" className="whitespace-nowrap text-[12px] tracking-[0.2em] text-white/70">{String(i + 1).padStart(2, "0")} / {String(n).padStart(2, "0")}</span>
          <button data-testid="lightbox-close-btn" onClick={onClose} aria-label="Close" className="p-2 text-white/80 hover:text-white"><X /></button>
        </div>
      </div>
      <div className="relative flex-1 min-h-0 px-4 sm:px-24 pb-8" onClick={(e) => e.stopPropagation()}
        onTouchStart={(e) => { touchX.current = e.touches[0].clientX; }} onTouchEnd={onTouchEnd}>
        <button data-testid="lightbox-prev-btn" aria-label="Previous" onClick={() => go(-1)} className={`${navBtn} left-6`}><ChevronLeft size={20} /></button>
        <img key={it.src} data-testid="lightbox-image" src={it.src} alt={it.cap} draggable={false}
          className="h-full w-full object-contain select-none animate-in fade-in zoom-in-95 duration-500" />
        <button data-testid="lightbox-next-btn" aria-label="Next" onClick={() => go(1)} className={`${navBtn} right-6`}><ChevronRight size={20} /></button>
      </div>
      <p className="sm:hidden pb-6 text-center text-[12px] uppercase tracking-[0.2em] text-white/70">Swipe to browse</p>
    </motion.div>
  );
};
